export default {
    add_new_field_section: "Add New Field Section",
    field_section: "Field section"
}